<template>
	<div class="row mb-1 mt-2 gap-1">
		<template v-for="(options, key) in options">
			<div v-if="options.length > 0 && key != hidePosition" class="col-12 col-lg">
				<template v-for="(option, index) in options">
					<h4 v-if="index == 0" class="text-start">{{ key == 'same' ? 'Front and rear' : key.charAt(0).toUpperCase() + key.slice(1) }} sizes</h4>
					<template v-if="key == 'same'">
						<confirm-size-radio :same-front-rear="true" :radio-id="'same_' + index" :radio-value="option.front" :checked="this.options.same.length == 1 && (this.options.front.length == 0 && this.options.rear.length == 0) ? true : false" @click="updateTyrePosition({position: 'same', value: option.front })"></confirm-size-radio>
					</template>
					<template v-else-if="key == 'front' && hidePosition != 'front'">
						<!-- hidePosition used for size options on BasketModal -->
						<confirm-size-radio :same-front-rear="false" :radio-id="'front_' + index" :radio-value="option.front" @click="updateTyrePosition({position: 'front', value: option.front })"></confirm-size-radio>
					</template>
					<template v-else-if="key == 'rear' && hidePosition != 'rear'">
						<!-- hidePosition used for size options on BasketModal -->
						<confirm-size-radio :same-front-rear="false" :radio-id="'rear_' + index" :radio-value="option.back" @click="updateTyrePosition({position: 'rear', value: option.back })"></confirm-size-radio>
					</template>
				</template>
			</div>
		</template>
		<div class="error-msg">{{ errors.size }}</div>
	</div>
</template>
<script>
    import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate';

    export default {
	    props: ['options', 'errors', 'hidePosition', 'updateSizeOptions'],
	    components: { VeeForm, Field, ErrorMessage},
	    methods: {
			updateTyrePosition(data) {
				this.emitter.emit('updateTyrePosition', data.position);

				//For use on the BasketModal, pre-selecting size form with selected width/profile/rim
				if(this.updateSizeOptions == true) {
					this.$emit('updateSelectedOption', data.value);
				}
			}
	    }
	}
</script>